import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const GridIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Grid",
    children: /*#__PURE__*/_jsx("path", {
      d: "M4.33 2h2.33c1.29 0 2.33 1.04 2.33 2.33v2.33c0 1.29-1.04 2.33-2.33 2.33H4.33C3.04 8.99 2 7.95 2 6.66V4.33C2 3.04 3.04 2 4.33 2m0 10.5h2.33c1.29 0 2.33 1.04 2.33 2.33v2.33c0 1.29-1.04 2.33-2.33 2.33H4.33C3.04 19.49 2 18.45 2 17.16v-2.33c0-1.29 1.04-2.33 2.33-2.33m0 10.5h2.33c1.29 0 2.33 1.04 2.33 2.33v2.33c0 1.29-1.04 2.33-2.33 2.33H4.33C3.04 29.99 2 28.95 2 27.66v-2.33C2 24.04 3.04 23 4.33 23m10.5-21h2.33c1.29 0 2.33 1.04 2.33 2.33v2.33c0 1.29-1.04 2.33-2.33 2.33h-2.33c-1.29 0-2.33-1.04-2.33-2.33V4.33C12.5 3.04 13.54 2 14.83 2m0 10.5h2.33c1.29 0 2.33 1.04 2.33 2.33v2.33c0 1.29-1.04 2.33-2.33 2.33h-2.33c-1.29 0-2.33-1.04-2.33-2.33v-2.33c0-1.29 1.04-2.33 2.33-2.33m0 10.5h2.33c1.29 0 2.33 1.04 2.33 2.33v2.33c0 1.29-1.04 2.33-2.33 2.33h-2.33c-1.29 0-2.33-1.04-2.33-2.33v-2.33c0-1.29 1.04-2.33 2.33-2.33m10.5-21h2.33c1.29 0 2.33 1.04 2.33 2.33v2.33c0 1.29-1.04 2.33-2.33 2.33h-2.33C24.04 8.99 23 7.95 23 6.66V4.33C23 3.04 24.04 2 25.33 2m0 10.5h2.33c1.29 0 2.33 1.04 2.33 2.33v2.33c0 1.29-1.04 2.33-2.33 2.33h-2.33c-1.29 0-2.33-1.04-2.33-2.33v-2.33c0-1.29 1.04-2.33 2.33-2.33m0 10.5h2.33c1.29 0 2.33 1.04 2.33 2.33v2.33c0 1.29-1.04 2.33-2.33 2.33h-2.33c-1.29 0-2.33-1.04-2.33-2.33v-2.33c0-1.29 1.04-2.33 2.33-2.33"
    })
  }));
};